document.addEventListener('DOMContentLoaded', function () {
  const contactSections = document.querySelectorAll('[data-beovea-contact-us]');
  if (!contactSections.length) return;

  contactSections.forEach((section) => {
    const inputs = section.querySelectorAll('.field__input');

    inputs.forEach((input) => {
      const syncState = () => {
        if (input.value && input.value.trim() !== '') {
          input.classList.add('is-filled');
        } else {
          input.classList.remove('is-filled');
        }
      };

      syncState();
      input.addEventListener('input', syncState);
      input.addEventListener('change', syncState);
      input.addEventListener('blur', syncState);
    });
  });
});